"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Field = require("./components/Field");

var _Container = require("./components/Container");

var _ButtonErase = require("./components/ButtonErase");

var _Loading = require("./components/Loading");

var _Message = require("./components/Message");

var _ButtonEye = require("./components/ButtonEye");

var _types = require("./types");

var _commons = require("./commons");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  component: _propTypes.string,
  placeholder: _propTypes.string,
  disabled: _propTypes.bool,
  cleanable: _propTypes.bool,
  loading: _propTypes.bool,
  value: _propTypes.string,
  message: _propTypes.string,
  error: _propTypes.string,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  type: (0, _propTypes.oneOf)(Object.values(_types.types))
} : {};

var Input = /*#__PURE__*/_react.default.forwardRef(function (_ref, _ref2) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'input' : _ref$component,
      className = _ref.className,
      placeholder = _ref.placeholder,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$cleanable = _ref.cleanable,
      cleanable = _ref$cleanable === void 0 ? false : _ref$cleanable,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return null;
  } : _ref$onBlur,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _types.types.TEXT : _ref$type,
      props = _objectWithoutProperties(_ref, ["component", "className", "placeholder", "loading", "cleanable", "disabled", "value", "message", "error", "onChange", "onBlur", "type"]);

  var _react$default$useSta = _react.default.useState(value),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      text = _react$default$useSta2[0],
      setText = _react$default$useSta2[1];

  var _react$default$useSta3 = _react.default.useState(false),
      _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
      showEraseButton = _react$default$useSta4[0],
      setShowEraseButton = _react$default$useSta4[1];

  var _react$default$useSta5 = _react.default.useState(type),
      _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
      currentType = _react$default$useSta6[0],
      setCurrentType = _react$default$useSta6[1];

  var inputRef = _react.default.useRef(null);

  var handleEraseButton = function handleEraseButton() {
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor((0, _commons.windowGlobal)().HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(inputRef.current, '');
    inputRef.current.dispatchEvent(new Event('input', {
      bubbles: true
    }));
    inputRef.current.focus();
  };

  var handleEyeButton = function handleEyeButton() {
    setCurrentType(currentType === _types.types.PASSWORD ? _types.types.TEXT : _types.types.PASSWORD);
  };

  var handleOnChangeInput = function handleOnChangeInput(e) {
    e.preventDefault();
    onChange(e);
    setText(e.currentTarget.value);
  };

  var updateShowEraseButton = _react.default.useCallback(function (field) {
    return setShowEraseButton(!loading && type !== _types.types.PASSWORD && cleanable && (field == null ? void 0 : field.length) > 0);
  }, [cleanable, loading, type]);

  var showMessage = function showMessage() {
    return message.length > 0 && error.length === 0;
  };

  var showEyeButton = function showEyeButton() {
    return type === _types.types.PASSWORD && !loading;
  };

  _react.default.useEffect(function () {
    updateShowEraseButton(value != null ? value : text);
  }, [value, text, updateShowEraseButton]);

  return (0, _core.jsx)(_Container.Container, {
    vertical: true
  }, (0, _core.jsx)(_Container.Container, null, (0, _core.jsx)(_Field.Field, (0, _extends2.default)({
    as: component,
    "data-testid": "input-text",
    className: className,
    placeholder: placeholder,
    disabled: disabled || loading,
    onChange: handleOnChangeInput,
    onBlur: onBlur,
    value: value != null ? value : text,
    ref: function ref(refElement) {
      if (_ref2) {
        _ref2.current = refElement;
      }

      inputRef.current = refElement;
    },
    type: currentType
  }, props)), showEraseButton && (0, _core.jsx)(_ButtonErase.ButtonErase, {
    onClick: handleEraseButton
  }), loading && (0, _core.jsx)(_Loading.Loading, null), showEyeButton() && (0, _core.jsx)(_ButtonEye.ButtonEye, {
    onClick: handleEyeButton,
    isClosed: currentType === _types.types.TEXT
  })), error.length > 0 && (0, _core.jsx)(_Message.Message, {
    error: true
  }, error), showMessage() && (0, _core.jsx)(_Message.Message, null, message));
});

exports.Input = Input;
Input.displayName = 'Input';
process.env.NODE_ENV !== "production" ? Input.propTypes = propTypes : void 0;
Input.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Input",
  "props": {
    "component": {
      "defaultValue": {
        "value": "'input'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "cleanable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "message": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "error": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "defaultValue": {
        "value": "types.TEXT",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "Object.values(types)"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};